function cov_kb9zu7jz4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Avatar.tsx";
  var hash = "9392ed7d0dfb0264b6d3a449c77dee76bb51c533";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Avatar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 46
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9392ed7d0dfb0264b6d3a449c77dee76bb51c533"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_kb9zu7jz4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_kb9zu7jz4();
var Icon = (cov_kb9zu7jz4().s[0]++, {
  name: 'avatar',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.4697 15.5H9.53051C8.25942 15.5 7.08825 16.1891 6.47096 17.3003L5.24887 19.5H18.7513L17.5292 17.3002C16.9119 16.1891 15.7408 15.5 14.4697 15.5ZM9.53051 13C7.35151 13 5.34378 14.1814 4.28556 16.0861L2.6508 19.0287C1.91021 20.3618 2.87415 22 4.39912 22H19.6011C21.126 22 22.09 20.3618 21.3494 19.0287L19.7146 16.0861C18.6564 14.1814 16.6487 13 14.4697 13H9.53051Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.0001 9.5C13.3808 9.5 14.5001 8.38071 14.5001 7C14.5001 5.61929 13.3808 4.5 12.0001 4.5C10.6194 4.5 9.50009 5.61929 9.50009 7C9.50009 8.38071 10.6194 9.5 12.0001 9.5ZM12.0001 12C14.7615 12 17.0001 9.76142 17.0001 7C17.0001 4.23858 14.7615 2 12.0001 2C9.23866 2 7.00009 4.23858 7.00009 7C7.00009 9.76142 9.23866 12 12.0001 12Z\" fill=\"currentColor\"/>"
});
export default Icon;